import { useDispatch, useSelector } from "react-redux";
import { handleChangeDataSheetProductComments } from '../../../../redux/actions/pages/product/sheetProductComments';
import { Sheet } from 'react-modal-sheet';

import React from "react";
import { Link } from 'react-router-dom';


const SheetProductCommentsMobile = () => {

	const dispatch = useDispatch();


	const { isSheetProductsCommentOpen } = useSelector(state => state.sheetProductComments);
	const { product, productComments } = useSelector(state => state.productDetails);
	
	

	const closeSheetProductComments = () => {
		dispatch( handleChangeDataSheetProductComments('isSheetProductsCommentOpen', false) );
	}

	const toPersianDigits = (num) => {
  		return num.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
	};

  	

    return (
    	
    	<Sheet style={{zIndex: "4"}} isOpen={isSheetProductsCommentOpen} onClose={closeSheetProductComments} detent="content-height" >
            <Sheet.Container >
                
                <Sheet.Content>

                    <div className="fixed z-4 top-0 left-0 flex items-center justify-center w-full BottomSheet_BottomSheet__pzJd_ BottomSheet_BottomSheet__animation___9TAU flex items-end w-full h-full" style={{zIndex: 6}}>
						<div className="bg-neutral-000 absolute shadow-2 w-full BottomSheet_BottomSheet__animation___9TAU BottomSheet_BottomSheet__content--mobile__wyx7Y w-screen overflow-hidden flex styles_bottomSheetContent__Qv8Te h-full" width={691} height={607} style={{transform: 'translateY(0px)'}}>
							<div className="grow">
								<div className="flex flex-col h-full overflow-y-hidden styles_ModalLayout__y3Bs1" style={{paddingTop: '80px'}}>
									<div className="w-full z-1 bg-neutral-000 fixed top-0 right-0 px-5" width={651} height={80}>
										<div className="flex items-center py-4">
											<div className="grow text-h5">
												<div className="flex flex-row justify-between items-center">
													<div className="break-words py-3 xs:py-0">
														<div className="flex items-center grow">
															<div onClick={closeSheetProductComments} className="flex cursor-pointer shrink-0 ml-2">
																<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
																	<use xlinkHref="#arrowRight" />
																</svg>
															</div>
															<p className="grow text-h4 text-neutral-900 mr-2">
																<span className="relative">{toPersianDigits(productComments.length)} دیدگاه
																</span>
															</p>
														</div>
													</div>
													{/*<div className="flex flex-row items-center gap-x-4">
														<div className="break-words py-3">
															<div className="flex items-center grow">
																<div className="flex shrink-0 ml-2" data-cro-id="pdp-comment-sort-icon">
																	<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-high-emphasis)'}}>
																		<use xlinkHref="#sort" />
																	</svg>
																</div>
																<p className="grow cursor-pointer whitespace-nowrap text-neutral-700  text-subtitle-strong">
																	<span className="relative" />
																</p>
															</div>
														</div>
													</div>*/}
												</div>
											</div>
										</div>
									</div>
									<div className="grow flex flex-col overflow-y-auto">
										<div className="grow flex flex-col styles_children__hHq5Q bg-app-background">
											<div className="mb-1 bg-neutral-000 shadow-1 px-4 py-3 relative">
												<div className="mb-4">
													<div className="flex items-center h-6">
														<p className="text-h1 font-bold ml-1 leading-none">{toPersianDigits(product.rate)}
														</p>
														<p className="text-h3"> از ۵ 
														</p>
													</div>
													<div className="flex items-center">
														<div className="inline-flex flex-nowrap relative mt-1">
															<div className="flex">
																<svg style={{width: '20px', height: '20px', fill: 'var(--color-icon-low-emphasis)'}}>
																	<use xlinkHref="#starFill" />
																</svg>
															</div>
															<div className="flex">
																<svg style={{width: '20px', height: '20px', fill: 'var(--color-icon-low-emphasis)'}}>
																	<use xlinkHref="#starFill" />
																</svg>
															</div>
															<div className="flex">
																<svg style={{width: '20px', height: '20px', fill: 'var(--color-icon-low-emphasis)'}}>
																	<use xlinkHref="#starFill" />
																</svg>
															</div>
															<div className="flex">
																<svg style={{width: '20px', height: '20px', fill: 'var(--color-icon-low-emphasis)'}}>
																	<use xlinkHref="#starFill" />
																</svg>
															</div>
															<div className="flex">
																<svg style={{width: '20px', height: '20px', fill: 'var(--color-icon-low-emphasis)'}}>
																	<use xlinkHref="#starFill" />
																</svg>
															</div>
															<div className="absolute right-0 top-0 overflow-hidden h-5" style={{width: `${parseFloat(product.rate) * 100 / 5}%`}}>
																<div className="absolute right-0 top-0 flex flex-nowrap">
																	<div className="flex">
																		<svg style={{width: '20px', height: '20px', fill: 'var(--color-icon-warning)'}}>
																			<use xlinkHref="#starFill" />
																		</svg>
																	</div>
																	<div className="flex">
																		<svg style={{width: '20px', height: '20px', fill: 'var(--color-icon-warning)'}}>
																			<use xlinkHref="#starFill" />
																		</svg>
																	</div>
																	<div className="flex">
																		<svg style={{width: '20px', height: '20px', fill: 'var(--color-icon-warning)'}}>
																			<use xlinkHref="#starFill" />
																		</svg>
																	</div>
																	<div className="flex">
																		<svg style={{width: '20px', height: '20px', fill: 'var(--color-icon-warning)'}}>
																			<use xlinkHref="#starFill" />
																		</svg>
																	</div>
																	<div className="flex">
																		<svg style={{width: '20px', height: '20px', fill: 'var(--color-icon-warning)'}}>
																			<use xlinkHref="#starFill" />
																		</svg>
																	</div>
																</div>
															</div>
														</div>
														<p className="text-neutral-400 body-2 mr-2 mt-1">از مجموع {toPersianDigits(product.totalPoint)} امتیاز
														</p>
													</div>
												</div>
												{/*<div className="py-4">
													<div className="break-words py-3">
														<div className="flex items-center grow">
															<p className="grow text-h5 text-neutral-900">
																<span className="relative">فیلتر بر اساس موضوع
																</span>
															</p>
														</div>
													</div>
													<div className="flex overflow-x-auto overflow-y-hidden hide-scrollbar">
														<div className="flex items-center styles_Chip__JGSAu styles_Chip--radius-medium__dD6KX styles_Chip--small__TArn9 flex-row-reverse py-1 px-2 text-body1-strong cursor-pointer px-4 py-4 text-body-1 whitespace-nowrap" data-cro-id="comment-intent">
															<span>کیفیت و کارایی
															</span>
														</div>
													</div>
												</div>*/}
											</div>
											<div className="flex h-full flex-col">
												<div id={17}>
													<div className="flex flex-wrap">
														{
															productComments.map((comment, key) => (
																<div key={`product-comments-${key}`} className="border-complete-b-200 overflow-x-hidden w-full ," style={{width: 'calc(100% + 0px)', marginBottom: '0px'}}>
																	<div className="mb-1 bg-neutral-000 shadow-1 px-4 py-3 relative">
																		<article className="py-3 lg:mt-0">
																			<div className="w-full flex justify-between">
																				<div className="w-full">
																					<div className="flex items-start w-full mt-1">
																						<div className="grow">
																							<div>
																								<div className="flex items-center">
																									<p className="text-caption text-neutral-400 inline">{comment.userName}
																									</p>
																									<div className="inline-flex items-center mr-2 Badge_Badge__QIekq Badge_Badge--small__ElV6O px-2 text-caption-strong" style={{backgroundColor: 'rgba(76, 175, 80, 0.1)', color: 'var(--color-hint-text-success)'}}>
																										<p className="inline-block  text-caption-strong">خریدار
																										</p>
																									</div>
																									<div className="flex my-2 mx-2">
																										<svg style={{width: '16px', height: '16px', fill: 'var(--color-icon-disable)'}}>
																											<use xlinkHref="#dotOutline" />
																										</svg>
																									</div>
																									<p className="text-caption text-neutral-400 inline">{toPersianDigits(comment.registerDate)}
																									</p>
																								</div>
																								<div className="inline-flex flex-nowrap relative mt-3">
																									<div className="flex">
																										<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
																											<use xlinkHref="#starOutline" />
																										</svg>
																									</div>
																									<div className="flex">
																										<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
																											<use xlinkHref="#starOutline" />
																										</svg>
																									</div>
																									<div className="flex">
																										<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
																											<use xlinkHref="#starOutline" />
																										</svg>
																									</div>
																									<div className="flex">
																										<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
																											<use xlinkHref="#starOutline" />
																										</svg>
																									</div>
																									<div className="flex">
																										<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
																											<use xlinkHref="#starOutline" />
																										</svg>
																									</div>
																									<div className="absolute right-0 top-0 overflow-hidden h-5" style={{width: `${parseFloat(comment.rate) * 100 / 5}%`}}>
																										<div className="absolute right-0 top-0 flex flex-nowrap">
																											<div className="flex">
																												<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-warning)'}}>
																													<use xlinkHref="#starFill" />
																												</svg>
																											</div>
																											<div className="flex">
																												<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-warning)'}}>
																													<use xlinkHref="#starFill" />
																												</svg>
																											</div>
																											<div className="flex">
																												<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-warning)'}}>
																													<use xlinkHref="#starFill" />
																												</svg>
																											</div>
																											<div className="flex">
																												<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-warning)'}}>
																													<use xlinkHref="#starFill" />
																												</svg>
																											</div>
																											<div className="flex">
																												<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-warning)'}}>
																													<use xlinkHref="#starFill" />
																												</svg>
																											</div>
																										</div>
																									</div>
																								</div>
																								<div className="flex items-center">
																									<div className="pt-2 flex gap-2 items-center">
																										<div className="flex">
																											<svg style={{width: '16px', height: '16px', fill: 'var(--color-icon-rating-4-5)'}}>
																												<use xlinkHref="#activeOutline" />
																											</svg>
																										</div>
																										{/*<p className="text-body-2 text-rating-4-5">دقیق و مناسب
																										</p>*/}
																									</div>
																								</div>
																							</div>
																							<div className="gap-y-3 flex flex-col">
																								<p className="text-body-1 text-neutral-900 mb-1 break-words">{comment.comment}
																								</p>
																							</div>
																							<div className="w-full flex items-center flex-row mt-3">
																								<div className="flex items-center">
																									<Link className="flex items-center" to={`/seller/${comment.sellerCode}`}>
																										<div className="flex text-neutral-700 ml-2">
																											<svg style={{width: '18px', height: '18px', fill: 'var(--color-icon-high-emphasis)'}}>
																												<use xlinkHref="#seller" />
																											</svg>
																										</div>
																										<p className="text-caption text-neutral-700 inline">{comment.sellerTitle}
																										</p>
																									</Link>
																									<div className="flex">
																										<svg style={{width: '16px', height: '16px', fill: 'var(--color-icon-disable)'}}>
																											<use xlinkHref="#dotOutline" />
																										</svg>
																									</div>
																									{ comment.optionTitle !== null &&
																										<>
																											{ comment.colorHex !== null ?
																												<div className="ml-2 inline-block rounded-circle styles_PdpCommentContentFooter__purchasedItem--color__GOLKc" style={{backgroundColor: `#${comment.colorHex}`}}>
																												</div>
																												:
																												<div className="flex ml-2">
																													<svg style={{width: '18px', height: '18px', fill: 'var(--color-icon-high-emphasis)'}}>
																														<use xlinkHref="#variationSize" />
																													</svg>
																												</div>
																											}
																											<p className="text-caption text-neutral-700 inline">{comment.optionTitle}
																											</p>
																										</>
																									}
																								</div>
																								{/*<div className="flex items-center text-neutral-500 pt-1 lg:justify-end mr-auto">
																									<div className="mr-auto lg:mr-0 flex items-center">
																										<button className="relative flex items-center user-select-none styles_btn__Q4MvL text-button-2 rounded-medium px-2 px-2 text-neutral-400" data-cro-id="pdp-comment-like">
																											<div className="flex items-center justify-center relative grow">
																												<p>۰
																												</p>
																												<div className="flex mr-1 text-neutral-400">
																													<svg style={{width: '20px', height: '20px', fill: 'var(--color-icon-low-emphasis)'}}>
																														<use xlinkHref="#thumbsUp" />
																													</svg>
																												</div>
																											</div>
																										</button>
																										<button className="relative flex items-center user-select-none styles_btn__Q4MvL text-button-2 rounded-medium mr-1 px-2 text-neutral-400" data-cro-id="pdp-comment-dislike">
																											<div className="flex items-center justify-center relative grow">
																												<p>۰
																												</p>
																												<div className="flex mr-1 text-neutral-400">
																													<svg style={{width: '20px', height: '20px', fill: 'var(--color-icon-low-emphasis)'}}>
																														<use xlinkHref="#thumbsDown" />
																													</svg>
																												</div>
																											</div>
																										</button>
																									</div>
																								</div>*/}
																							</div>
																						</div>
																					</div>
																				</div>
																				{/*<div className="mr-auto pt-1">
																					<div>
																						<button data-cro-id="pdp-comment-three-dots" type="button">
																							<div className="flex">
																								<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-low-emphasis)'}}>
																									<use xlinkHref="#moreVert" />
																								</svg>
																							</div>
																						</button>
																					</div>
																				</div>*/}
																			</div>
																		</article>
																	</div>
																</div>
															))
														}
													</div>
												</div>
											</div>
											{/*<div className="fixed bottom-0 left-0 styles_PdpCommentSectionModal__addCommentWrapper___6SGc">
												<button className="relative flex items-center user-select-none styles_btn__Q4MvL text-button-1 styles_btn--large__1Muai styles_btn--primary__y0GEv rounded-medium styles_PdpCommentSectionModal__addCommentButton__dIn21" data-cro-id="pdp-su-comment">
													<div className="flex items-center justify-center relative grow">
														<span>ثبت دیدگاه
														</span>
														<div className="flex mr-2">
															<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-white)'}}>
																<use xlinkHref="#comment" />
															</svg>
														</div>
													</div>
												</button>
											</div>*/}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

                </Sheet.Content>
            </Sheet.Container>
            <Sheet.Backdrop />
        </Sheet>

    );
}

export default SheetProductCommentsMobile;